import { useEffect } from "react"

import { useActiveOrganization, useAuthentication } from "@/contexts"
import { datadogRum } from "@datadog/browser-rum"

export const useDatadogRumSetUser = () => {
  const { authenticatedUser } = useAuthentication()
  const { activeOrganization } = useActiveOrganization()

  // Set Datadog RUM user
  useEffect(() => {
    const userId = authenticatedUser?.id

    if (!authenticatedUser || !userId) {
      return
    }

    datadogRum.setUser({
      email: authenticatedUser.email,
      id: userId,
      name: authenticatedUser.name,
      organization: activeOrganization?.name ?? "",
      role: authenticatedUser.role,
    })
  }, [authenticatedUser, activeOrganization?.name])
}
